export var DidNotGetInsiderFreeDutiesIA = function DidNotGetInsiderFreeDutiesIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHY_I_DID_NOT_RECEIVE_FREE_DUTIES(strictLocalize);
    },
    getDescription: function getDescription() {
      return [INSIDER_OFFERS_FREE_DUTIES_WITH_SELECT_BRANDS(strictLocalize)];
    }
  };
};
var WHY_I_DID_NOT_RECEIVE_FREE_DUTIES = function WHY_I_DID_NOT_RECEIVE_FREE_DUTIES(strictLocalize) {
  return strictLocalize({
    id: "/eaC3R",
    defaultMessage: [{
      "type": 0,
      "value": "Porque não tive direitos aduaneiros gratuitos na minha encomenda?"
    }]
  });
};
var INSIDER_OFFERS_FREE_DUTIES_WITH_SELECT_BRANDS = function INSIDER_OFFERS_FREE_DUTIES_WITH_SELECT_BRANDS(strictLocalize) {
  return strictLocalize({
    id: "Kl7yLn",
    defaultMessage: [{
      "type": 0,
      "value": "É importante salientar que tem acesso a direitos aduaneiros gratuitos em marcas selecionadas com a sua subscrição Insider. Embora este benefício não seja aplicável em todo o marketplace, pode identificar facilmente as marcas elegíveis enquanto navega na Faire. Só tem de prestar atenção às marcas assinaladas com \"Envio e direitos aduaneiros gratuitos com Insider\" e um símbolo de chave azul. Além disso, se a sua subscrição Insider cobrir os direitos aduaneiros numa determinada marca, essa informação será indicada no check-out."
    }]
  });
};